module.exports = __webpack_public_path__ + "static/og-64f81e258396ce5bb4bffcdd35bd45f3.png";